import {computed} from 'vue'
import {useSessionStorage} from '@vueuse/core'
import {useGlobalStore} from '@/stores/global'

export function useAssistantDebugSettings() {
  const globalStore = useGlobalStore()
  const debugMode = useSessionStorage(
    computed(() => `assistant-debug-mode-${globalStore.selectedUserId}`),
    false
  )
  const showInvokedTools = useSessionStorage(
    computed(() => `assistant-show-invoked-tools-${globalStore.selectedUserId}`),
    false
  )
  const isAdmin = computed(() => globalStore.hasAuthority('ADMIN'))
  const showDebugDetails = computed(() => isAdmin.value && debugMode.value)

  return {debugMode, isAdmin, showDebugDetails, showInvokedTools}
}
